module.exports = __webpack_public_path__ + "media/images/themes/mandy/11-f0335210b8ad87c73f36394b68a8681c.png";